import React, { useState } from 'react';
import {
  CheckCircle2, XCircle, Tag, Building2, Globe, UserCheck,
  Sparkles, ShieldCheck,
} from 'lucide-react';
import { formatDate, formatDateTime } from '../utils/helpers';
import { StatusBadge, PriorityBadge, RiskBadge } from './Shared';

export default function LeoReview({ tasks, navigateTo, currentUser, addApproval }) {
  const reviewTasks = tasks.filter(t => t.status === 'review' && t.needLeoApproval);

  return (
    <div>
      <h1 className="text-xl font-bold text-slate-800 mb-6">审批中心</h1>
      <div className="card overflow-hidden">
        {reviewTasks.length === 0 && (
          <div className="p-10 text-center text-slate-400">
            <CheckCircle2 className="w-12 h-12 mx-auto mb-3 text-emerald-400" />
            <p>暂无待审核任务</p>
          </div>
        )}
        {reviewTasks.map(task => (
          <ReviewCard key={task.id} task={task} navigateTo={navigateTo} addApproval={addApproval} />
        ))}
      </div>
    </div>
  );
}

function ReviewCard({ task, navigateTo, addApproval }) {
  const [comment, setComment] = useState('');
  const [showReject, setShowReject] = useState(false);

  function handleApprove() {
    addApproval(task.id, 'approve', '审批通过');
  }

  function handleReject() {
    if (!comment.trim()) { alert('请输入驳回原因'); return; }
    addApproval(task.id, 'reject', comment);
    setComment('');
    setShowReject(false);
  }

  return (
    <div className="p-5 border-b border-slate-100 last:border-b-0">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0 cursor-pointer" onClick={() => navigateTo('detail', task.id)}>
          <div className="flex items-center space-x-2 flex-wrap gap-y-1">
            <span className="text-xs font-mono text-slate-400">{task.id}</span>
            <StatusBadge status={task.status} />
            <PriorityBadge priority={task.priority} />
            <RiskBadge level={task.riskLevel} />
            {task.riskLevel === 'high' && <span className="text-xs font-medium text-rose-600 bg-rose-50 px-2 py-0.5 rounded border border-rose-200">高风险自动审批</span>}
          </div>
          <h3 className="text-base font-semibold text-slate-800 mt-1">{task.title}</h3>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500 mt-2">
            <span className="flex items-center"><Tag className="w-3.5 h-3.5 mr-1" />{task.type}</span>
            <span className="flex items-center"><Building2 className="w-3.5 h-3.5 mr-1" />{task.store}</span>
            <span className="flex items-center"><Globe className="w-3.5 h-3.5 mr-1" />{task.site}</span>
            <span className="flex items-center"><UserCheck className="w-3.5 h-3.5 mr-1" />{task.assignee}</span>
            <span className="flex items-center">截止 {formatDate(task.dueDate)}</span>
          </div>
          {task.aiOutput && (
            <div className="mt-3 p-3 bg-indigo-50 border border-indigo-100 rounded-lg text-sm text-indigo-800">
              <Sparkles className="w-4 h-4 inline mr-1" />{task.aiOutput}
            </div>
          )}
        </div>
        <div className="ml-4 flex flex-col space-y-2 shrink-0">
          <button onClick={handleApprove} className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 rounded-lg">
            <CheckCircle2 className="w-4 h-4 mr-1.5" /> 通过
          </button>
          <button onClick={() => setShowReject(!showReject)} className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-rose-600 hover:bg-rose-700 rounded-lg">
            <XCircle className="w-4 h-4 mr-1.5" /> 驳回
          </button>
        </div>
      </div>
      {showReject && (
        <div className="mt-3 flex items-start space-x-2">
          <textarea className="flex-1 text-sm border border-slate-200 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-rose-500" rows={2} placeholder="请输入驳回原因..." value={comment} onChange={e => setComment(e.target.value)} />
          <button onClick={handleReject} className="px-4 py-2 text-sm font-medium text-white bg-rose-600 hover:bg-rose-700 rounded-lg">确认驳回</button>
        </div>
      )}
    </div>
  );
}
